const statusOptions = {
    0: {
        color: '#00dea3',
        label: 'APT',
    },
    1: {
        color: '#FFCC40',
        label: 'PART_APT',
    },
    2: {
        color: '#FA5A7C',
        label: 'UN_APT',
    }
};

export default statusOptions